import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import mdPranab from '../../assets/images/md_Pranab.png';
import prospectPulseLogo from '../../assets/images/prospectpulselogo.png';
import genericImage from '../../assets/images/generic-profile.jpg';

const AboutUs = () => {
  return (
    <div className="py-5">
      <Container>
        {/* Hero Section */}
        <Row className="mb-5">
          <Col lg={12} className="text-center">
            <div className="d-flex align-items-center justify-content-center gap-3 mb-4">
              <img 
                src={prospectPulseLogo} 
                alt="ProspectPulse Logo" 
                style={{ maxHeight: '80px', width: 'auto' }}
              />
              <h1 className="display-4 fw-bold mb-0">ProspectPulse</h1>
            </div>
            <p className="lead text-muted">
              Empowering businesses to grow through innovative digital solutions
            </p>
          </Col>
        </Row>

        {/* CEO Message */}
        <Row className="mb-5">
          <Col lg={12}>
            <Card className="border-0 shadow-sm bg-primary bg-opacity-10">
              <Card.Body className="p-5">
                <Row className="align-items-center">
                  <Col lg={3} className="text-center mb-4 mb-lg-0">
                    <img 
                      src={mdPranab} 
                      alt="Pranab Kumar Sinha - CEO" 
                      className="mb-3"
                      style={{ width: '240px', height: '315px', objectFit: 'cover' }}
                    />
                    <h5 className="fw-bold mb-1">Pranab Kumar Sinha</h5>
                    <p className="text-muted mb-0">Managing Director (CEO)</p>
                  </Col>
                  <Col lg={9}>
                    <h3 className="fw-bold mb-4">Message from Our CEO</h3>
                    <p className="lead mb-4">
                      "At ProspectPulse, we believe that every business deserves the opportunity to thrive in the digital age. Our mission is to bridge the gap between traditional business practices and modern digital solutions."
                    </p>
                    <p className="mb-3">
                      We understand the challenges that businesses face in today's competitive landscape. That's why we've built a comprehensive platform that not only helps you establish a strong online presence but also drives sustainable growth through innovative lead generation and customer engagement strategies.
                    </p>
                    <p className="mb-0">
                      Our vision is to become the most trusted partner for businesses seeking digital transformation. We are committed to delivering excellence, maintaining transparency, and building long-term relationships with our clients. Together, let's build a future where every business can reach its full potential."
                    </p>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Leadership Team */}
        <Row className="mb-5">
          <Col lg={12}>
            <h2 className="fw-bold mb-4 text-center">Our Leadership Team</h2>
            <Row>
              <Col lg={4} className="mb-4">
                <Card className="h-100 border-0 shadow-sm text-center">
                  <Card.Body className="p-4">
                    <img 
                      src={mdPranab} 
                      alt="Pranab Kumar Sinha" 
                      className="rounded-circle mb-3"
                      style={{ width: '120px', height: '120px', objectFit: 'cover' }}
                    />
                    <h5 className="fw-bold mb-1">Pranab Kumar Sinha</h5>
                    <p className="text-primary fw-semibold mb-2">Managing Director (CEO)</p>
                    <p className="text-muted small">
                      Leading our vision and strategic direction with over 15 years of experience in business strategies and digital transformation.
                    </p>
                  </Card.Body>
                </Card>
              </Col>
              <Col lg={4} className="mb-4">
                <Card className="h-100 border-0 shadow-sm text-center">
                  <Card.Body className="p-4">
                    <img 
                      src={genericImage}
                      alt="Avijit Sinha" 
                      className="rounded-circle mb-3"
                      style={{ width: '120px', height: '120px', objectFit: 'cover' }}
                    />
                    <h5 className="fw-bold mb-1">Avijit Sinha</h5>
                    <p className="text-primary fw-semibold mb-2">Legal Advisor</p>
                    <p className="text-muted small">
                      Ensuring compliance and providing expert legal guidance to protect our clients' interests and business operations.
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>

        {/* Mission & Vision */}
        <Row className="mb-5">
          <Col lg={6} className="mb-4">
            <Card className="h-100 border-0 shadow-sm">
              <Card.Body className="p-4">
                <h3 className="fw-bold mb-3">Our Mission</h3>
                <p className="text-muted">
                  To provide businesses with comprehensive digital solutions that drive growth, 
                  increase leads, and establish a strong online presence. We believe every 
                  business deserves the tools to succeed in the digital age.
                </p>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={6} className="mb-4">
            <Card className="h-100 border-0 shadow-sm">
              <Card.Body className="p-4">
                <h3 className="fw-bold mb-3">Our Vision</h3>
                <p className="text-muted">
                  To become the trusted partner for businesses seeking digital transformation, 
                  offering innovative solutions that simplify complex processes and deliver 
                  measurable results.
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* What We Do */}
        <Row className="mb-5">
          <Col lg={12}>
            <h2 className="fw-bold mb-4 text-center">What We Do</h2>
            <Row>
              <Col md={4} className="mb-4">
                <div className="text-center p-3">
                  <div className="bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '80px', height: '80px' }}>
                    <i className="bi bi-globe fs-1 text-primary"></i>
                  </div>
                  <h5 className="fw-bold">Website Development</h5>
                  <p className="text-muted">
                    Professional, responsive websites that convert visitors into customers
                  </p>
                </div>
              </Col>
              <Col md={4} className="mb-4">
                <div className="text-center p-3">
                  <div className="bg-success bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '80px', height: '80px' }}>
                    <i className="bi bi-graph-up fs-1 text-success"></i>
                  </div>
                  <h5 className="fw-bold">Lead Generation</h5>
                  <p className="text-muted">
                    Strategic campaigns that attract and convert high-quality leads
                  </p>
                </div>
              </Col>
              <Col md={4} className="mb-4">
                <div className="text-center p-3">
                  <div className="bg-warning bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '80px', height: '80px' }}>
                    <i className="bi bi-headset fs-1 text-warning"></i>
                  </div>
                  <h5 className="fw-bold">24/7 Support</h5>
                  <p className="text-muted">
                    Dedicated support team ready to help you succeed
                  </p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>

        {/* Why Choose Us */}
        <Row className="mb-5">
          <Col lg={12}>
            <h2 className="fw-bold mb-4 text-center">Why Choose ProspectPulse</h2>
            <Row>
              <Col lg={6} className="mb-3">
                <div className="d-flex align-items-start">
                  <i className="bi bi-check-circle-fill text-success me-3 mt-1"></i>
                  <div>
                    <h6 className="fw-bold">Fast Turnaround</h6>
                    <p className="text-muted small">Get your website up and running in 2-3 weeks</p>
                  </div>
                </div>
              </Col>
              <Col lg={6} className="mb-3">
                <div className="d-flex align-items-start">
                  <i className="bi bi-check-circle-fill text-success me-3 mt-1"></i>
                  <div>
                    <h6 className="fw-bold">Affordable Pricing</h6>
                    <p className="text-muted small">Transparent pricing with no hidden fees</p>
                  </div>
                </div>
              </Col>
              <Col lg={6} className="mb-3">
                <div className="d-flex align-items-start">
                  <i className="bi bi-check-circle-fill text-success me-3 mt-1"></i>
                  <div>
                    <h6 className="fw-bold">SSL Security</h6>
                    <p className="text-muted small">Free SSL certificates for all websites</p>
                  </div>
                </div>
              </Col>
              <Col lg={6} className="mb-3">
                <div className="d-flex align-items-start">
                  <i className="bi bi-check-circle-fill text-success me-3 mt-1"></i>
                  <div>
                    <h6 className="fw-bold">Mobile Friendly</h6>
                    <p className="text-muted small">Responsive design that works on all devices</p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>

        {/* Contact Section */}
        <Row className="mb-5">
          <Col lg={12}>
            <Card className="border-0 shadow-sm bg-primary bg-opacity-10">
              <Card.Body className="p-5 text-center">
                <h3 className="fw-bold mb-3">Ready to Get Started?</h3>
                <p className="text-muted mb-4">
                  Let's discuss how ProspectPulse can help grow your business
                </p>
                <div className="d-flex justify-content-center gap-3 flex-wrap">
                  <a href="mailto:support@prospectpulse.in" className="btn btn-primary">
                    <i className="bi bi-envelope me-2"></i>
                    Email Us
                  </a>
                  <a href="https://wa.me/9354200796" className="btn btn-success">
                    <i className="bi bi-whatsapp me-2"></i>
                    WhatsApp
                  </a>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AboutUs; 